/**
 * This file holds the actions/mutations types
 * For more information about why this is needed
 * check here https://vuex.vuejs.org/guide/mutations.html#using-constants-for-mutation-types
 */
export const SET_ENV = "SET_ENV";

export const GET_AUDIENCE_SIZES = "GET_AUDIENCE_SIZES";
export const SET_AUDIENCE_SIZES = "SET_AUDIENCE_SIZES";
export const SET_BUCKET_SIZES = "SET_BUCKET_SIZES";

export const GET_PART_NUMBER = "GET_PART_NUMBER";
export const SET_PART_NUMBER = "SET_PART_NUMBER";

export const GET_PDM = "GET_PDM";
export const SET_PDM = "SET_PDM";
export const SET_CAID = "SET_CAID";
export const SET_PDM_MODEL = "SET_PDM_MODEL";
export const GET_CONFIGURATION = "GET_CONFIGURATION";
export const SET_CONFIGURATION = "SET_CONFIGURATION";
export const SET_PROPERTY_CONFIGURATION = "SET_PROPERTY_CONFIGURATION";

export const GET_AVAILABLE_SWATCHES = "GET_AVAILABLE_SWATCHES";
export const SET_AVAILABLE_SWATCHES = "SET_AVAILABLE_SWATCHES";
export const GET_AVAILABLE_SWATCHES_BY_ID = "GET_AVAILABLE_SWATCHES_BY_ID";
export const GET_AVAILABLE_SWATCHES_BY_SUBGROUP = "GET_AVAILABLE_SWATCHES_BY_SUBGROUP";

export const GET_AVAILABLE_STICKERS = "GET_AVAILABLE_STICKERS";
export const SET_AVAILABLE_STICKERS = "SET_AVAILABLE_STICKERS";
export const GET_AVAILABLE_STICKER_GROUPS = "GET_AVAILABLE_STICKER_GROUPS";
export const SET_AVAILABLE_STICKER_GROUPS = "SET_AVAILABLE_STICKER_GROUPS";
export const GET_PRODUCT_IMAGES_FROM_SCENE = "GET_PRODUCT_IMAGES_FROM_SCENE";

export const GET_GCC = "GET_GCC";

export const RETURN_AVERGAGE_RGB = "RETURN_AVERGAGE_RGB";

export const SEND_GROUP_EMAIL = "SEND_GROUP_EMAIL";
export const ADD_TO_FAVORITES = "ADD_TO_FAVORITES";

export const SET_SCREEN_SIZE = "SET_SCREEN_SIZE";

export const SET_ACTIVE_COMPONENT = "SET_ACTIVE_COMPONENT";

export const CHANGE_VISIBILITY_EXTERNAL_HEADERS = "CHANGE_VISIBILITY_EXTERNAL_HEADERS";
export const SET_TRAY_DISABLED_STATUS = "SET_TRAY_DISABLED_STATUS";

export const GET_BUCKET_SIZE = "GET_BUCKET_SIZE";
export const SET_BUCKET_SIZE = "SET_BUCKET_SIZE";

export const SHARE_IN_STORE = "SHARE_IN_STORE";

export const SET_MODEL_VIEWS = "SET_MODEL_VIEWS";

export const SET_IS_PRODUCTION = "SET_IS_PRODUCTION";

export const SET_IS_SPLASH_MODAL_OPEN = "SET_IS_SPLASH_MODAL_OPEN";

export const SET_IS_DESIGN_TRANSFERING = "SET_IS_DESIGN_TRANSFERING";
export const SET_IS_DESIGN_TRANSFER_APPLIED = "SET_IS_DESIGN_TRANSFER_APPLIED";

export const SET_IS_FINISH_MY_DESIGN_APPLIED= "SET_IS_FINISH_MY_DESIGN_APPLIED";

export const GET_PATTEN_MAKER_AVAILABLE_CONTENT = "GET_PATTEN_MAKER_AVAILABLE_CONTENT";
export const SET_PATTEN_MAKER_AVAILABLE_CONTENT = "SET_PATTEN_MAKER_AVAILABLE_CONTENT";
export const SET_QUERY_PARAMS = "SET_QUERY_PARAMS";
export const SET_ERROR_MODAL_PROCESS = "SET_ERROR_MODAL_PROCESS";
export const SET_VSF_ACTIVE = "SET_VSF_ACTIVE";
export const SET_INITIAL_TIME = "SET_INITIAL_TIME";
export const SET_IS_RANDOMIZE_APPLIED = "SET_IS_RANDOMIZE_APPLIED";
export const SET_RECAPTCHA_PROPERTY = "SET_RECAPTCHA_PROPERTY";
export const SET_WINDOW_WIDTH = "SET_WINDOW_WIDTH";

// canvas
export const CALL_FAVORITES_API = "CALL_FAVORITES_API";
export const FETCH_HEADERS_DATA = "FETCH_HEADERS_DATA";
export const SET_HEADERS_DATA = "SET_HEADERS_DATA";
export const SET_USER_AUTH = "SET_USER_AUTH";

//Customs tools
export const FETCH_CUSTOMS_TOOL_DATA = "FETCH_CUSTOMS_TOOL_DATA";
